export default __webpack_public_path__ + "static/media/01AW1NOV65.5e65108b.jpg";